import {Component} from "react";
import XLSX from "xlsx";
import moment from "moment";
import validator from 'validator';
import {
    BelgeEnum,
    DespatchEnum,
    ExternalCustomerEnum,
    InvoiceEnum,
    SerbestVoucherEnum, SigortaEnum,
    StockEnum,
    VoucherEnum
} from "../../../helper/enums";
import {getExemptions} from "../../../helper/invoiceHelper";
import {Decimal} from "decimal.js";
import {VirtualHost} from "../../../constants";


class GetEnumDataAndValidation extends Component {

    static getInvoiceEnum(sheetcopy, rowLength) {
        let invoiceEnum = [];

        for (let colon = rowLength.s.r; colon <= rowLength.e.c; colon++) {
            let cell2 = sheetcopy[XLSX.utils.encode_cell({r: 0, c: colon})];
            if (cell2.v === "FATURA_NO") {
                invoiceEnum.push({
                    [colon]: "documentNo"
                });
            } else if (cell2.v === "SENARYO_TURU") {
                invoiceEnum.push({
                    [colon]: "profileId"
                });
            } else if (cell2.v === "FATURA_TIPI") {
                invoiceEnum.push({
                    [colon]: "invoiceTypeCode"
                });
            } else if (cell2.v === "FATURA_TARIHI") {
                invoiceEnum.push({
                    [colon]: "issueDate"
                });
            } else if (cell2.v === "FATURA_SAATI") {
                invoiceEnum.push({
                    [colon]: "issueTime"
                });
            } else if (cell2.v === "ALICI_POSTA_KUTUSU_ETIKETI") {
                invoiceEnum.push({
                    [colon]: "destinationUrn"
                });
            } else if (cell2.v === "GONDERICI_BIRIM_ETIKETI") {
                invoiceEnum.push({
                    [colon]: "sourceUrn"
                });
            } else if (cell2.v === "ALICI_EPOSTA") {
                invoiceEnum.push({
                    [colon]: "email"
                });
            } else if (cell2.v === "PARA_BIRIMI") {
                invoiceEnum.push({
                    [colon]: "documentCurrencyCode"
                });
            } else if (cell2.v === "KUR_DEGERI") {
                invoiceEnum.push({
                    [colon]: "paymentExchangeRate"
                });
            } else if (cell2.v === "ALICI_VKN_TCKN") {
                invoiceEnum.push({
                    [colon]: "vknTckn"
                });
            } else if (cell2.v === "ALICI_UNVAN") {
                invoiceEnum.push({
                    [colon]: "formattedName"
                });
            } else if (cell2.v === "ALICI_ADI") {
                invoiceEnum.push({
                    [colon]: "givenName"
                });
            } else if (cell2.v === "ALICI_SOYADI") {
                invoiceEnum.push({
                    [colon]: "familyName"
                });
            } else if (cell2.v === "ILCE") {
                invoiceEnum.push({
                    [colon]: "citySubdivisionName"
                });
            } else if (cell2.v === "IL") {
                invoiceEnum.push({
                    [colon]: "cityName"
                });
            } else if (cell2.v === "ULKE") {
                invoiceEnum.push({
                    [colon]: "countryName"
                });
            } else if (cell2.v === "ADRES") {
                invoiceEnum.push({
                    [colon]: "streetName"
                });
            } else if (cell2.v === "VERGI_DAIRESI") {
                invoiceEnum.push({
                    [colon]: "taxOffice"
                });
            } else if (cell2.v === "VERGI_DAIRESI") {
                invoiceEnum.push({
                    [colon]: "taxOffice"
                });
            } else if (cell2.v === "URUN_ADI") {
                invoiceEnum.push({
                    [colon]: "itemName"
                });
            } else if (cell2.v === "MIKTAR") {
                invoiceEnum.push({
                    [colon]: "quantity"
                });
            } else if (cell2.v === "BIRIM_FIYAT") {
                invoiceEnum.push({
                    [colon]: "unitPrice"
                });
            } else if (cell2.v === "BIRIM") {
                invoiceEnum.push({
                    [colon]: "unit"
                });
            } else if (cell2.v === "ISKONTO(%)") {
                invoiceEnum.push({
                    [colon]: "iskontoPercentage"
                });
            } else if (cell2.v === "KDV(%)") {
                invoiceEnum.push({
                    [colon]: "kdvPercentage"
                });
            }
            else if (cell2.v === "İSTİSNA KODU") {
                invoiceEnum.push({
                    [colon]: "exemptionReasonCode"
                });
            }
            else if (cell2.v === "FATURA AÇIKLAMASI") {
                invoiceEnum.push({
                    [colon]: "note"
                });
            }
            else if (cell2.v === "İRSALİYE NO") {
                invoiceEnum.push({
                    [colon]: "referenceId"
                });
            }
            else if (cell2.v === "İRSALİYE TARİHİ") {
                invoiceEnum.push({
                    [colon]: "referenceIssueDate"
                });
            }
            else if (cell2.v === "GTİP NUMARASI") {
                invoiceEnum.push({
                    [colon]: "gtip"
                });
            }
            else if (cell2.v === "KDV_TEVKIFATI") {
                invoiceEnum.push({
                    [colon]: "tevkifatAmount"
                });
            }
            else if (cell2.v === "BUNDAN SONRAKI ALANLAR INTERNET UZERINDEN SATIS ICINDIR!") {
                invoiceEnum.push({
                    [colon]: "internetSaleArea"
                });
            }
            else if (cell2.v === "WEB_SITESI") {
                invoiceEnum.push({
                    [colon]: "webSite"
                });
            }
            else if (cell2.v === "ODEME_SEKLI") {
                invoiceEnum.push({
                    [colon]: "paymentMethod"
                });
            }
            else if (cell2.v === "ODEME_DETAYI") {
                invoiceEnum.push({
                    [colon]: "paymentDetails"
                });
            }
            else if (cell2.v === "ODEME_TARIHI") {
                invoiceEnum.push({
                    [colon]: "paymentDate"
                });
            }
            else if (cell2.v === "TASIYICI_ADI") {
                invoiceEnum.push({
                    [colon]: "carrierFirstName"
                });
            }
            else if (cell2.v === "TASIYICI_SOYADI") {
                invoiceEnum.push({
                    [colon]: "carrierFamilyName"
                });
            }
            else if (cell2.v === "TASIYICI_UNVAN") {
                invoiceEnum.push({
                    [colon]: "carrierTitle"
                });
            }
            else if (cell2.v === "TASIYICI_VKN_TCKN") {
                invoiceEnum.push({
                    [colon]: "carrierVknTckn"
                });
            }
            else if (cell2.v === "GONDERIM_TARIHI") {
                invoiceEnum.push({
                    [colon]: "deliveryDate"
                });
            }
            else if (cell2.v === "ALICI_TELEFON_NO") {
                invoiceEnum.push({
                    [colon]: "telephone"
                });
            }
            else if (cell2.v === "IADE_FATURA_NUMARASI") {
                invoiceEnum.push({
                    [colon]: "invoiceNumber"
                });
            }
            else if (cell2.v === "IADE_FATURA_TARIHI") {
                invoiceEnum.push({
                    [colon]: "iadeIssueDate"
                });
            }
            else if (cell2.v === "IADE_FATURA_SAATI") {
                invoiceEnum.push({
                    [colon]: "iadeIssueTime"
                });
            }
        }
        return invoiceEnum;
    }

    static getSigortaEnum(sheetcopy, rowLength) {
        let sigortaEnum = [];

        for (let colon = rowLength.s.r; colon <= rowLength.e.c; colon++) {
            let cell2 = sheetcopy[XLSX.utils.encode_cell({r: 0, c: colon})];
            if (cell2.v === "SIGORTA_NO") {
                sigortaEnum.push({
                    [colon]: "documentNo"
                });
            } else if (cell2.v === "SIGORTA_TARIHI") {
                sigortaEnum.push({
                    [colon]: "issueDate"
                });
            } else if (cell2.v === "SIGORTA_SAATI") {
                sigortaEnum.push({
                    [colon]: "issueTime"
                });
            } else if (cell2.v === "PARA_BIRIMI") {
                sigortaEnum.push({
                    [colon]: "documentCurrencyCode"
                });
            }else if (cell2.v === "KUR_DEGERI") {
                sigortaEnum.push({
                    [colon]: "paymentExchangeRate"
                });
            } else if (cell2.v === "ALICI_VKN_TCKN") {
                sigortaEnum.push({
                    [colon]: "vknTckn"
                });
            } else if (cell2.v === "ALICI_UNVAN") {
                sigortaEnum.push({
                    [colon]: "formattedName"
                });
            } else if (cell2.v === "ALICI_ADI") {
                sigortaEnum.push({
                    [colon]: "givenName"
                });
            } else if (cell2.v === "ALICI_SOYADI") {
                sigortaEnum.push({
                    [colon]: "familyName"
                });
            } else if (cell2.v === "ALICI_ETIKETI") {
                sigortaEnum.push({
                    [colon]: "postboxAlias"
                });
            } else if (cell2.v === "ILCE") {
                sigortaEnum.push({
                    [colon]: "citySubdivisionName"
                });
            } else if (cell2.v === "IL") {
                sigortaEnum.push({
                    [colon]: "cityName"
                });
            } else if (cell2.v === "ULKE") {
                sigortaEnum.push({
                    [colon]: "countryName"
                });
            } else if (cell2.v === "ADRES") {
                sigortaEnum.push({
                    [colon]: "streetName"
                });
            } else if (cell2.v === "VERGI_DAIRESI") {
                sigortaEnum.push({
                    [colon]: "taxOffice"
                });
            } else if (cell2.v === "AÇIKLAMA") {
                sigortaEnum.push({
                    [colon]: "itemName"
                });
            } else if (cell2.v === "ISTIHSAL_KOMISYONU") {
                sigortaEnum.push({
                    [colon]: "productCommissionPrice"
                });
            } else if (cell2.v === "IPTAL_KOMISYONU") {
                sigortaEnum.push({
                    [colon]: "cancelCommissionPrice"
                });
            } else if (cell2.v === "DÖNEM_BAŞLANGIÇ_TARIHI") {
                sigortaEnum.push({
                    [colon]: "periodStartDateTime"
                });
            } else if (cell2.v === "DÖNEM_BITIŞ_TARIHI") {
                sigortaEnum.push({
                    [colon]: "periodEndDateTime"
                });
            } else if (cell2.v === "SIGORTA_AÇIKLAMASI") {
                sigortaEnum.push({
                    [colon]: "note"
                });
            }
        }
        return sigortaEnum;
    }

    static getExcelRequestBank(sheetcopy, rowLength) {
        let requestEnum = [];
        for (let colon = rowLength.s.r; colon <= rowLength.e.c; colon++) {
            let cell2 = sheetcopy[XLSX.utils.encode_cell({r: 0, c: colon})];
            // if (cell2.v === "urun_hizmet") {
            //     requestEnum.push({
            //         [colon]: "urun_hizmet"
            //     });
            // } else
                if (cell2.v === "olay_numarasi") {
                requestEnum.push({
                    [colon]: "olay_numarasi"
                });
            }
            //     else if (cell2.v === "urun_id") {
            //     requestEnum.push({
            //         [colon]: "urun_id"
            //     });
            // }
        }
        return requestEnum;
    }

    static getBelgeEnum(sheetcopy, rowLength) {
        let belgeEnum = [];

        for (let colon = rowLength.s.r; colon <= rowLength.e.c; colon++) {
            let cell2 = sheetcopy[XLSX.utils.encode_cell({r: 0, c: colon})];
            if (cell2.v === "BELGE_NO") {
                belgeEnum.push({
                    [colon]: "documentNo"
                });
            } else if (cell2.v === "FATURA_TIPI") {
                belgeEnum.push({
                    [colon]: "documentTypeCode"
                });
            } else if (cell2.v === "FATURA_TARIHI") {
                belgeEnum.push({
                    [colon]: "issueDate"
                });
            } else if (cell2.v === "FATURA_SAATI") {
                belgeEnum.push({
                    [colon]: "issueTime"
                });
            } else if (cell2.v === "ALICI_EPOSTA") {
                belgeEnum.push({
                    [colon]: "email"
                });
            } else if (cell2.v === "PARA_BIRIMI") {
                belgeEnum.push({
                    [colon]: "documentCurrencyCode"
                });
            } else if (cell2.v === "KUR_DEGERI") {
                belgeEnum.push({
                    [colon]: "paymentExchangeRate"
                });
            } else if (cell2.v === "ALICI_VKN_TCKN") {
                belgeEnum.push({
                    [colon]: "vknTckn"
                });
            } else if (cell2.v === "ALICI_UNVAN") {
                belgeEnum.push({
                    [colon]: "formattedName"
                });
            } else if (cell2.v === "ALICI_ADI") {
                belgeEnum.push({
                    [colon]: "givenName"
                });
            } else if (cell2.v === "ALICI_SOYADI") {
                belgeEnum.push({
                    [colon]: "familyName"
                });
            } else if (cell2.v === "ILCE") {
                belgeEnum.push({
                    [colon]: "citySubdivisionName"
                });
            } else if (cell2.v === "IL") {
                belgeEnum.push({
                    [colon]: "cityName"
                });
            } else if (cell2.v === "ULKE") {
                belgeEnum.push({
                    [colon]: "countryName"
                });
            } else if (cell2.v === "ADRES") {
                belgeEnum.push({
                    [colon]: "streetName"
                });
            } else if (cell2.v === "VERGI_DAIRESI") {
                belgeEnum.push({
                    [colon]: "taxOffice"
                });
            } else if (cell2.v === "VERGI_DAIRESI") {
                belgeEnum.push({
                    [colon]: "taxOffice"
                });
            } else if (cell2.v === "URUN_ADI") {
                belgeEnum.push({
                    [colon]: "itemName"
                });
            } else if (cell2.v === "MIKTAR") {
                belgeEnum.push({
                    [colon]: "quantity"
                });
            } else if (cell2.v === "BIRIM_FIYAT") {
                belgeEnum.push({
                    [colon]: "unitPrice"
                });
            } else if (cell2.v === "BIRIM") {
                belgeEnum.push({
                    [colon]: "unit"
                });
            } else if (cell2.v === "ISKONTO(%)") {
                belgeEnum.push({
                    [colon]: "iskontoPercentage"
                });
            } else if (cell2.v === "KDV(%)") {
                belgeEnum.push({
                    [colon]: "kdvPercentage"
                });
            }
            else if (cell2.v === "İSTİSNA KODU") {
                belgeEnum.push({
                    [colon]: "exemptionReasonCode"
                });
            }
            else if (cell2.v === "FATURA AÇIKLAMASI") {
                belgeEnum.push({
                    [colon]: "note"
                });
            }
            else if (cell2.v === "İRSALİYE NO") {
                belgeEnum.push({
                    [colon]: "referenceId"
                });
            }
            else if (cell2.v === "İRSALİYE TARİHİ") {
                belgeEnum.push({
                    [colon]: "referenceIssueDate"
                });
            }
            else if (cell2.v === "KDV_TEVKIFATI") {
                belgeEnum.push({
                    [colon]: "tevkifatAmount"
                });
            }
        }
        return belgeEnum;
    }

    static getVoucherEnum(sheetcopy, rowLength) {
        let VoucherEnum = [];
        for (let colon = rowLength.s.r; colon <= rowLength.e.c; colon++) {
            let cell2 = sheetcopy[XLSX.utils.encode_cell({r: 0, c: colon})];

            if (cell2.v === "TARIH(GÜN/AY/YIL Saat:Dakika:saniye formatında okunur.)") {
                VoucherEnum.push({
                    [colon]: "issueDate"
                });
            } else if (cell2.v === "ADI SOYADI") {
                VoucherEnum.push({
                    [colon]: "fullName"
                });
            } else if (cell2.v === "Makbuz_No") {
                VoucherEnum.push({
                    [colon]: "documentNo"
                });
            } else if (cell2.v === "T.C. NO") {
                VoucherEnum.push({
                    [colon]: "vknTckn"
                });
            } else if (cell2.v === "ADRES(EK BİLGİ /İLÇE / İL)") {
                VoucherEnum.push({
                    [colon]: "fullAddress"
                });
            } else if (cell2.v === "ÜRÜN") {
                VoucherEnum.push({
                    [colon]: "itemName"
                });
            } else if (cell2.v === "MİKTAR") {
                VoucherEnum.push({
                    [colon]: "quantity"
                });
            } else if (cell2.v === "B.FİYAT") {
                VoucherEnum.push({
                    [colon]: "unitPrice"
                });
            } else if (cell2.v === "TUTAR") {
                VoucherEnum.push({
                    [colon]: "lineExtensionAmount"
                });
            } else if (cell2.v === "GV_STOPAJI_KODU") {
                VoucherEnum.push({
                    [colon]: "gvStoppageCode"
                });
            } else if (cell2.v === "BORSA_TES_UC_TUTARI") {
                VoucherEnum.push({
                    [colon]: "borsaAmount"
                });
            } else if (cell2.v === "MERA_FONU_TUTARI") {
                VoucherEnum.push({
                    [colon]: "meraAmount"
                });
            } else if (cell2.v === "SGK_PRIM_KESİNTİ_TUTARI") {
                VoucherEnum.push({
                    [colon]: "sgkAmount"
                });
            } else if (cell2.v === "BIRIM") {
                VoucherEnum.push({
                    [colon]: "unit"
                });
            }else if (cell2.v === "SATICI_MAL_KODU") {
                VoucherEnum.push({
                    [colon]: "stockCode"

                });
            }
        }
        return VoucherEnum;
    }

    static getSVoucherEnum(sheetcopy, rowLength) {
        let serbestVoucherEnum = [];
        for (let colon = rowLength.s.r; colon <= rowLength.e.c; colon++) {
            let cell2 = sheetcopy[XLSX.utils.encode_cell({r: 0, c: colon})];

            if (cell2.v === "TARIH(GÜN/AY/YIL Saat:Dakika:saniye formatında okunur.)") {
                serbestVoucherEnum.push({
                    [colon]: "issueDate"
                });
            } else if (cell2.v === "Makbuz_No") {
                serbestVoucherEnum.push({
                    [colon]: "documentNo"
                });
            } else if (cell2.v === "ALICI_VKN_TCKN") {
                serbestVoucherEnum.push({
                    [colon]: "vknTckn"
                });
            } else if (cell2.v === "ALICI_UNVAN") {
                serbestVoucherEnum.push({
                    [colon]: "formattedName"
                });
            } else if (cell2.v === "ALICI_ADI") {
                serbestVoucherEnum.push({
                    [colon]: "givenName"
                });
            } else if (cell2.v === "ALICI_SOYADI") {
                serbestVoucherEnum.push({
                    [colon]: "familyName"
                });
            } else if (cell2.v === "URUN") {
                serbestVoucherEnum.push({
                    [colon]: "itemName"
                });
            } else if (cell2.v === "ILCE") {
                serbestVoucherEnum.push({
                    [colon]: "citySubdivisionName"
                });
            } else if (cell2.v === "IL") {
                serbestVoucherEnum.push({
                    [colon]: "cityName"
                });
            } else if (cell2.v === "KDV_TEVKIFATI(₺)") {
                serbestVoucherEnum.push({
                    [colon]: "tevkifatAmount"
                });
            } else if (cell2.v === "KDV_GERCEK(₺)") {
                serbestVoucherEnum.push({
                    [colon]: "gercekAmount"
                });
            } else if (cell2.v === "GV_STOPAJI_KODU") {
                serbestVoucherEnum.push({
                    [colon]: "gvStoppageCode"
                });
            } else if (cell2.v === "BRUT_UCRET(₺)") {
                serbestVoucherEnum.push({
                    [colon]: "lineExtensionAmount"
                });
            } else if (cell2.v === "ACIKLAMA") {
                serbestVoucherEnum.push({
                    [colon]: "note"
                });
            }else if (cell2.v === "GV_STOPAJI_ORANI") {
                serbestVoucherEnum.push({
                    [colon]: "percentage"
                });
            }
        }
        return serbestVoucherEnum;
    }

    static getDespatchEnum(sheetcopy, rowLength) {
        let despatchEnum = [];

        for (let colon = rowLength.s.r; colon <= rowLength.e.c; colon++) {
            let cell2 = sheetcopy[XLSX.utils.encode_cell({r: 0, c: colon})];
            if (cell2.v === "Irsaliye_No") {
                despatchEnum.push({
                    [colon]: "documentNo"
                });
            } else if (cell2.v === "ALICI_ADI") {
                despatchEnum.push({
                    [colon]: "givenName"
                });
            } else if (cell2.v === "ALICI_SOYADI") {
                despatchEnum.push({
                    [colon]: "familyName"
                });
            } else if (cell2.v === "ALICI_VKN_TCKN") {
                despatchEnum.push({
                    [colon]: "vknTckn"
                });
            } else if (cell2.v === "IL") {
                despatchEnum.push({
                    [colon]: "cityName"
                });
            } else if (cell2.v === "ALICI_ETIKETI") {
                despatchEnum.push({
                    [colon]: "postboxAlias"
                });
            } else if (cell2.v === "ILCE") {
                despatchEnum.push({
                    [colon]: "citySubdivisionName"
                });
            } else if (cell2.v === "GONDERICI_BIRIM_ETIKETI") {
                despatchEnum.push({
                    [colon]: "sourceUrn"
                });
            } else if (cell2.v === "IRSALIYE_TARIHI") {
                despatchEnum.push({
                    [colon]: "issueDate"
                });
            } else if (cell2.v === "ALICI_UNVAN") {
                despatchEnum.push({
                    [colon]: "formattedName"
                });
            } else if (cell2.v === "URUN") {
                despatchEnum.push({
                    [colon]: "itemName"
                });
            } else if (cell2.v === "TESLIMAT_EDİLECEK_ILCE") {
                despatchEnum.push({
                    [colon]: "deliveryCitySubdivision"
                });
            } else if (cell2.v === "TESLIMAT_EDİLECEK_POSTA_KODU") {
                despatchEnum.push({
                    [colon]: "deliveryPostalZone"
                });
            } else if (cell2.v === "TESLIMAT_EDİLECEK_IL") {
                despatchEnum.push({
                    [colon]: "deliveryCity"
                });
            } else if (cell2.v === "TASIYICI_VKN/TCKN(ŞAHIS VE FİRMA İÇİN ZORUNLU)") {
                despatchEnum.push({
                    [colon]: "carrierId"
                });
            } else if (cell2.v === "SEVK_TARIHI") {
                despatchEnum.push({
                    [colon]: "actualDespatchDatetime"
                });
            } else if (cell2.v === "TAŞIYICI_TÜRÜ") {
                despatchEnum.push({
                    [colon]: "deliveryType"
                });
            } else if (cell2.v === "TASIYICI_UNVAN(FİRMA İÇİN ZORUNLU)") {
                despatchEnum.push({
                    [colon]: "carrierTitle"
                });
            } else if (cell2.v === "ŞOFÖR_ADI(ŞAHIS İÇİN ZORUNLU)") {
                despatchEnum.push({
                    [colon]: "driverFirstName"
                });
            } else if (cell2.v === "ŞOFÖR_SOYADI(ŞAHIS İÇİN ZORUNLU)") {
                despatchEnum.push({
                    [colon]: "driverFamilyName"
                });
            } else if (cell2.v === "MIKTAR") {
                despatchEnum.push({
                    [colon]: "quantity"
                });
            } else if (cell2.v === "BIRIM_FIYAT") {
                despatchEnum.push({
                    [colon]: "unitPrice"
                });
            } else if (cell2.v === "FATURA AÇIKLAMASI") {
                despatchEnum.push({
                    [colon]: "note"
                });
            } else if (cell2.v === "BIRIM") {
                despatchEnum.push({
                    [colon]: "unit"
                });
            } else if (cell2.v === "PLAKA") {
                despatchEnum.push({
                    [colon]: "licensePlateID"
                });
            } else if (cell2.v === "TESLIMAT_EDİLECEK_ADRES") {
                despatchEnum.push({
                    [colon]: "deliveryStreetName"
                });
            } else if (cell2.v === "IRSALIYE_SAATI") {
                despatchEnum.push({
                    [colon]: "issueTime"
                });
            } else if (cell2.v === "SEVK_SAATİ") {
                despatchEnum.push({
                    [colon]: "actualDespatchDatehour"
                });
            } else if (cell2.v === "ADRES") {
                despatchEnum.push({
                    [colon]: "streetName"
                });
            } else if (cell2.v === "SIPARIS_NO") {
                despatchEnum.push({
                    [colon]: "orderReferenceNumber"
                });
            } else if (cell2.v === "SIPARIS_TARIHI") {
                despatchEnum.push({
                    [colon]: "orderReferenceDate"
                });
            }
        }
        return despatchEnum;
    }

    static getStockEnum(sheetcopy, rowLength) {
        let stockEnum = [];

        for (let colon = rowLength.s.r; colon <= rowLength.e.c; colon++) {
            let cell2 = sheetcopy[XLSX.utils.encode_cell({r: 0, c: colon})];
            if (cell2.v === "Ürün-Hizmet_Kodu") {
                stockEnum.push({
                    [colon]: "stockCode"
                });
            } else if (cell2.v === "Ürün-Hizmet_Adı") {
                stockEnum.push({
                    [colon]: "stockName"
                });
            } else if (cell2.v === "Kdv_Alış(%)") {
                stockEnum.push({
                    [colon]: "kdvBuy"
                });
            } else if (cell2.v === "Kdv_Satış(%)") {
                stockEnum.push({
                    [colon]: "kdvSell"
                });
            } else if (cell2.v === "Birim_Fiyat_Alış") {
                stockEnum.push({
                    [colon]: "priceBuy"
                });
            } else if (cell2.v === "Birim_Fiyat_Satış") {
                stockEnum.push({
                    [colon]: "priceSell"
                });
            } else if (cell2.v === "Para_Birimi") {
                stockEnum.push({
                    [colon]: "currency"
                });
            } else if (cell2.v === "Birim") {
                stockEnum.push({
                    [colon]: "unit"
                });
            } else if (cell2.v === "Ürün-Hizmet_Etiket") {
                stockEnum.push({
                    [colon]: "alias"
                });
            } else if (cell2.v === "Ürün-Hizmet_Açıklaması") {
                stockEnum.push({
                    [colon]: "explanation"
                });
            } else if (cell2.v === "Kdv_Alış_İstisna_Sebebi") {
                stockEnum.push({
                    [colon]: "kdvPurchaseExemption"
                });
            } else if (cell2.v === "Kdv_Satış_İstisna_Sebebi") {
                stockEnum.push({
                    [colon]: "kdvSellExemption"
                });
            } else if (cell2.v === "Gtip_Numarası") {
                stockEnum.push({
                    [colon]: "gtip"
                });
            }
        }
        return stockEnum;
    }

    static getExternalCustomerEnum(sheetcopy, rowLength) {
        let externalCustomerEnum = [];

        for (let colon = rowLength.s.r; colon <= rowLength.e.c; colon++) {
            let cell2 = sheetcopy[XLSX.utils.encode_cell({r: 0, c: colon})];
            if (cell2.v === "VKN/TCKN_(Zorunlu)" || cell2.v === "VKN/TCKN" ) {
                externalCustomerEnum.push({
                    [colon]: "vkn_tckn"
                });
            } else if (cell2.v === "Unvan_(Vkn_için_zorunlu)" ||cell2.v === "Unvan" ) {
                externalCustomerEnum.push({
                    [colon]: "formatted_name"
                });
            } else if (cell2.v === "Adı_(Tckn_için_zorunlu)" || cell2.v === "Ad") {
                externalCustomerEnum.push({
                    [colon]: "given_name"
                });
            } else if (cell2.v === "Orta_Adı") {
                externalCustomerEnum.push({
                    [colon]: "middle_name"
                });
            } else if (cell2.v === "Soyadı_(Tckn_için_zorunlu)" || cell2.v === "Soyad") {
                externalCustomerEnum.push({
                    [colon]: "family_name"
                });
            } else if (cell2.v === "Ticaret_Odası") {
                externalCustomerEnum.push({
                    [colon]: "commerce_chamber"
                });
            } else if (cell2.v === "Vergi_Dairesi_Şehir") {
                externalCustomerEnum.push({
                    [colon]: "city"
                });
            } else if (cell2.v === "Vergi_Dairesi") {
                externalCustomerEnum.push({
                    [colon]: "tax_office"
                });
            } else if (cell2.v === "Mersis_No") {
                externalCustomerEnum.push({
                    [colon]: "mersis_number"
                });
            } else if (cell2.v === "Ticaret_Sicil_No") {
                externalCustomerEnum.push({
                    [colon]: "trade_registration_number"
                });
            } else if (cell2.v === "Müşteri_Tipi_(Zorunlu)" ||cell2.v === "Müşteri_Tipi") {
                externalCustomerEnum.push({
                    [colon]: "customer_type"
                });
            } else if (cell2.v === "Başlangıç_Bakiyesi") {
                externalCustomerEnum.push({
                    [colon]: "initial_balance"
                });
            } else if (cell2.v === "Müşteri_Risk_Limiti") {
                externalCustomerEnum.push({
                    [colon]: "customer_risk_limit"
                });
            } else if (cell2.v === "Adres_Adı_(Zorunlu)" || cell2.v === "Adres_Adı") {
                externalCustomerEnum.push({
                    [colon]: "address_name"
                });
            } else if (cell2.v === "Yetkili_Kişi") {
                externalCustomerEnum.push({
                    [colon]: "contact_person"
                });
            } else if (cell2.v === "Ülke_(Zorunlu)" || cell2.v === "Ülke") {
                externalCustomerEnum.push({
                    [colon]: "country_name"
                });
            } else if (cell2.v === "Şehir_(Zorunlu)" || cell2.v === "Şehir") {
                externalCustomerEnum.push({
                    [colon]: "city_name"
                });
            } else if (cell2.v === "İlçe_(Zorunlu)" || cell2.v === "İlçe") {
                externalCustomerEnum.push({
                    [colon]: "city_subdivision_name"
                });
            } else if (cell2.v === "Web_Sitesi") {
                externalCustomerEnum.push({
                    [colon]: "web_site"
                });
            } else if (cell2.v === "E_Posta") {
                externalCustomerEnum.push({
                    [colon]: "email"
                });
            } else if (cell2.v === "Telefon") {
                externalCustomerEnum.push({
                    [colon]: "telephone"
                });
            } else if (cell2.v === "Faks") {
                externalCustomerEnum.push({
                    [colon]: "fax"
                });
            } else if (cell2.v === "Mahalle/Cadde") {
                externalCustomerEnum.push({
                    [colon]: "postal_address_region"
                });
            } else if (cell2.v === "Bina_Adı") {
                externalCustomerEnum.push({
                    [colon]: "building_name"
                });
            } else if (cell2.v === "Bina_No") {
                externalCustomerEnum.push({
                    [colon]: "building_no"
                });
            } else if (cell2.v === "Daire_No") {
                externalCustomerEnum.push({
                    [colon]: "postal_address_room"
                });
            } else if (cell2.v === "Posta_Kodu") {
                externalCustomerEnum.push({
                    [colon]: "postal_zone"
                });
            } else if (cell2.v === "Banka_Adı") {
                externalCustomerEnum.push({
                    [colon]: "bank_name"
                });
            } else if (cell2.v === "IBAN") {
                externalCustomerEnum.push({
                    [colon]: "iban"
                });
            } else if (cell2.v === "Yabancı_Müşteri") {
                externalCustomerEnum.push({
                    [colon]: "is_foreign_customer"
                });
            }
        }
        return externalCustomerEnum;
    }

    static despatchValidation(rowData, row, controlObject) {
        let error = "";
        if (rowData["vknTckn"] !== null && row !== 0) {
            if(isNaN(rowData["vknTckn"]) || (rowData["vknTckn"].toString().length !== 11 && rowData["vknTckn"].toString().length !== 10) || rowData["vknTckn"] < 0 || rowData["vknTckn"].toString().includes("+")){
                error = error + " <strong>" + (row + 1) + ". satırdaki TCKN_VKN satırı 10 veya 11 haneli pozitif bir sayı olmalıdır, harf içeremez. </strong><br/>";
                controlObject = 0;
            }else {
                if (rowData["vknTckn"].toString().length === 10 && (rowData["formattedName"] === "" || !rowData["formattedName"])) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki verilerinizin unvan alanı boş olamaz </strong><br/>";
                    controlObject = 0;
                } else if (rowData["vknTckn"].toString().length === 11 && row !== 0 && ((rowData["givenName"] === "" || !rowData["givenName"]) || (rowData["familyName"] === "" || !rowData["familyName"]))) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki verilerinizin müşteri ad veya soyad alanları boş olamaz </strong><br/>";
                    controlObject = 0;
                }
            }

            if (!!rowData["givenName"] && rowData["givenName"].toString().length > 45) {
                error = error + " <strong>" + (row + 1) + ". satırdaki alıcı adı alanı maksimum 45 karakter olmalıdır </strong><br/>";
                controlObject = 0;
            }

            if (!!rowData["familyName"] && rowData["familyName"].toString().length > 45) {
                error = error + " <strong>" + (row + 1) + ". satırdaki alıcı soyadı alanı maksimum 45 karakter olmalıdır </strong><br/>";
                controlObject = 0;
            }

        } else if (row !== 0) {
            error = error + " <strong>" + (row + 1) + ". satırdaki VKN/TCKN alanı boş olamaz </strong><br/>";
            controlObject = 0;
        }

        if (row !== 0) {
            if (rowData["cityName"] === "" || !rowData["cityName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IL' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["postboxAlias"] === "" || !rowData["postboxAlias"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ALICI_ETIKETI' alanını boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["documentNo"] === "" || !rowData["documentNo"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IRSALIYE NO' alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if (rowData["citySubdivisionName"] === "" || !rowData["citySubdivisionName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ILCE' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["sourceUrn"] === "" || !rowData["sourceUrn"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'GONDERICI_BIRIM_ETIKETI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["issueDate"] === "" || !rowData["issueDate"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IRSALIYE_TARIHI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["issueDate"],"DD-MM-YYYY").isValid("DD-MM-YYYY"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IRSALIYE_TARIHI'formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            } else if (rowData["issueTime"] === "" || !rowData["issueTime"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IRSALIYE_SAATI' alanı  boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["issueTime"], "HH:mm:ss").isValid("HH:mm:ss")) || !(moment(rowData["issueDate"] + " " + rowData["issueTime"],"DD-MM-YYYYTHH:mm:ss").isValid("DD-MM-YYYYTHH:mm:ss"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IRSALIYE_SAATI'formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            } else if (rowData["itemName"] === "" || !rowData["itemName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'URUN' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["deliveryCitySubdivision"] === "" || !rowData["deliveryCitySubdivision"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TESLIMAT_EDİLECEK_ILCE' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["deliveryPostalZone"] === "" || !rowData["deliveryPostalZone"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TESLIMAT_EDİLECEK_POSTA_KODU' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["deliveryCity"] === "" || !rowData["deliveryCity"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TESLIMAT_EDİLECEK_IL' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["deliveryType"] === "" || !rowData["deliveryType"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TAŞIYICI_TÜRÜ' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["deliveryType"].toUpperCase() !== "FIRMA" && rowData["deliveryType"].toUpperCase() !== "ŞAHIS") {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TAŞIYICI_TÜRÜ' alanı sadece ŞAHIS veya FIRMA olmalıdır </strong><br/>";
                controlObject = 0;
            } else if ((rowData["carrierId"] === "" || !rowData["carrierId"])) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TASIYICI_VKN/TCKN' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["actualDespatchDatetime"] === "" || !rowData["actualDespatchDatetime"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'SEVK_TARIHI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["actualDespatchDatetime", "DD-MM-YYYY"]).isValid("DD-MM-YYYY"))){
                error = error + " <strong>" + (row + 1) + ". satırdaki 'SEVK_TARIHI'formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["actualDespatchDatehour"], "HH:mm:ss").isValid("HH:mm:ss")) || !(moment(  rowData["actualDespatchDatetime"] + " " + rowData["actualDespatchDatehour"],"DD-MM-YYYYTHH:mm:ss").isValid("DD-MM-YYYYTHH:mm:ss"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'SEVK_SAATI'formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            } else if (rowData["deliveryType"].toUpperCase() === "FIRMA" && (rowData["carrierTitle"] === "" || !rowData["carrierTitle"])) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TASIYICI_UNVAN' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["licensePlateID"] === "" || !rowData["licensePlateID"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'PLAKA' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["deliveryType"].toUpperCase() === "ŞAHIS" && (rowData["driverFirstName"] === "" || !rowData["driverFirstName"])) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ŞOFÖR_ADI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["deliveryType"].toUpperCase() === "ŞAHIS" && (rowData["driverFamilyName"] === "" || !rowData["driverFamilyName"])) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ŞOFÖR_SOYADI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["quantity"] >= 0) || rowData["quantity"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'MIKTAR' alanı boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            }
            /*else if (!(rowData["unitPrice"] >= 0) || rowData["unitPrice"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'BIRIM_FIYAT' alanı boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            }*/
            else if (rowData["unit"] === "" || !rowData["unit"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'BIRIM' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["deliveryStreetName"] === "" || !rowData["deliveryStreetName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ADRES' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            }else if(rowData["orderReferenceNumber"] && rowData["orderReferenceNumber"].length > 20 ){
                error = error + " <strong>" + (row + 1) + ". satırdaki 'SIPARIS_NO' alanı 20 karakterden fazla olmamalıdır </strong><br/>";
                controlObject = 0;
            }
        }
        return {error, controlObject};
    }

    static sigortaValidation(rowData, row, controlObject) {
        let error = "";
        if (rowData["vknTckn"] !== null && row !== 0) {
            if(isNaN(rowData["vknTckn"]) || (rowData["vknTckn"].toString().length !== 11 && rowData["vknTckn"].toString().length !== 10) || rowData["vknTckn"] < 0 || rowData["vknTckn"].toString().includes("+")){
                error = error + " <strong>" + (row + 1) + ". satırdaki TCKN_VKN satırı 10 veya 11 haneli pozitif bir sayı olmalıdır, harf içeremez. </strong><br/>";
                controlObject = 0;
            }else {
                if (rowData["vknTckn"].toString().length === 10 && (rowData["formattedName"] === "" || !rowData["formattedName"])) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki verilerinizin unvan alanı boş olamaz </strong><br/>";
                    controlObject = 0;
                } else if (rowData["vknTckn"].toString().length === 11 && row !== 0 && ((rowData["givenName"] === "" || !rowData["givenName"]) || (rowData["familyName"] === "" || !rowData["familyName"]))) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki verilerinizin müşteri ad veya soyad alanları boş olamaz </strong><br/>";
                    controlObject = 0;
                }
            }

            if (!!rowData["givenName"] && rowData["givenName"].toString().length > 45) {
                error = error + " <strong>" + (row + 1) + ". satırdaki alıcı adı alanı maksimum 45 karakter olmalıdır </strong><br/>";
                controlObject = 0;
            }

            if (!!rowData["familyName"] && rowData["familyName"].toString().length > 45) {
                error = error + " <strong>" + (row + 1) + ". satırdaki alıcı soyadı alanı maksimum 45 karakter olmalıdır </strong><br/>";
                controlObject = 0;
            }

        } else if (row !== 0) {
            error = error + " <strong>" + (row + 1) + ". satırdaki VKN/TCKN alanı boş olamaz </strong><br/>";
            controlObject = 0;
        }

        const periodStartDateTime = rowData["periodStartDateTime"].trim();
        const periodEndDateTime = rowData["periodEndDateTime"].trim()

        console.log(periodEndDateTime, (moment(periodEndDateTime, "DD-MM-YYYY HH:mm:ss", true).isValid()), (moment(periodStartDateTime, "DD-MM-YYYY HH:mm:ss", true).isValid()))

        if (row !== 0) {
            if (rowData["cityName"] === "" || !rowData["cityName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IL' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["postboxAlias"] === "" || !rowData["postboxAlias"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ALICI_ETIKETI' alanını boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["documentNo"] === "" || !rowData["documentNo"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'SIGORTA NO' alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if (rowData["citySubdivisionName"] === "" || !rowData["citySubdivisionName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ILCE' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["countryName"] === "" || !rowData["countryName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ULKE' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["streetName"] === "" || !rowData["streetName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ADRES' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            }  else if (rowData["issueDate"] === "" || !rowData["issueDate"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'SIGORTA TARIHI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["issueDate"],"DD-MM-YYYY").isValid("DD-MM-YYYY"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'SIGORTA TARIHI'formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            } else if (rowData["issueTime"] === "" || !rowData["issueTime"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'SIGORTA SAATI' alanı  boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["issueTime"], "HH:mm:ss").isValid("HH:mm:ss")) || !(moment(rowData["issueDate"] + " " + rowData["issueTime"],"DD-MM-YYYYTHH:mm:ss").isValid("DD-MM-YYYYTHH:mm:ss"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'SIGORTA SAATI' formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            }else if (rowData["documentCurrencyCode"] === "" || !rowData["documentCurrencyCode"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'PARA_BIRIMI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["itemName"] === "" || !rowData["itemName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'AÇIKLAMA' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            }else if (!(rowData["cancelCommissionPrice"] >= 0) || rowData["cancelCommissionPrice"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IPTAL KOMİSYONU' alanı boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            }else if (!(rowData["productCommissionPrice"] >= 0) || rowData["productCommissionPrice"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ISTIHSAL KOMİSYONU' alanı boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            } else if (!(moment(periodStartDateTime, "DD-MM-YYYY HH:mm:ss", true).isValid())) {
                error += " <strong>" + (row + 1) + ". satırdaki 'Dönem Başlangıç Tarihi' formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            }
            else if (!(moment(periodEndDateTime, "DD-MM-YYYY HH:mm:ss", true).isValid())) {
                error += " <strong>" + (row + 1) + ". satırdaki 'Dönem Bitiş Tarihi' formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            }
        }
        return {error, controlObject};
    }

    static stockValidation(rowData, row, controlObject) {
        let error = "";

        if (row !== 0) {
            if (rowData["stockCode"] === "" || !rowData["stockCode"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'Stok_Kodu' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["stockName"] === "" || !rowData["stockName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'Stok_Adı' alanını boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["kdvBuy"] !== 0 && (rowData["kdvBuy"] === "" || !rowData["kdvBuy"])) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'Kdv_Alış(%)' alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if ( rowData["kdvSell"] !== 0 && (rowData["kdvSell"] === "" || !rowData["kdvSell"])) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'Kdv_Satış(%)' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["priceBuy"] !== 0 && (rowData["priceBuy"] === "" || !rowData["priceBuy"])) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'Birim_Fiyat_Alış' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["priceSell"] !== 0 && (rowData["priceSell"] === "" || !rowData["priceSell"])) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'Birim_Fiyat_Satış' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["currency"] === "" || !rowData["currency"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'Para_Birimi' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["unit"] === "" || !rowData["unit"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'Birim' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["gtip"] && (rowData["gtip"].toString().length !== 12 || isNaN(rowData["gtip"]) || rowData["gtip"] < 0 || rowData["gtip"].toString().includes("+"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'Gtip Numarası' harf içeremez, negatif olamaz ve 12 basamaktan oluşmalıdır. </strong><br/>";
                controlObject = 0;
            }
        }
        return {error, controlObject};
    }

    static externalCustomerValidation(rowData, row, controlObject) {
        let error = "";

        if (row !== 0) {
            if (rowData["vkn_tckn"] === "" || !rowData["vkn_tckn"]){
                error = error + " <strong>" + (row ) + ". satırdaki 'VKN/TCKN_(Zorunlu)' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["vkn_tckn"].toString().length !== 11 && rowData["vkn_tckn"].toString().length !== 10) {
                error = error + " <strong>" + (row ) + ". satırdaki 'VKN/TCKN_(Zorunlu)' alanı 10 ya da 11 hane olmalıdır </strong><br/>";
                controlObject = 0;
            } else if (/\s/.test(rowData["vkn_tckn"])) {
                error = error + " <strong>" + (row ) + ". satırdaki 'VKN/TCKN_(Zorunlu)' alanına boş karakter girilemez. </strong><br/>";
                controlObject = 0;
            } else if ((rowData["vkn_tckn"].toString().length === 10 || rowData["is_foreign_customer"].toUpperCase() === "EVET") && (rowData["formatted_name"] === "" || !rowData["formatted_name"])) {
                error = error + " <strong>" + (row ) + ". satırdaki 'Unvan_(Vkn_için_zorunlu)' alanını boş olamaz </strong><br/>";
                controlObject = 0;
            } else if ((rowData["vkn_tckn"].toString().length === 11 || rowData["is_foreign_customer"].toUpperCase() === "EVET") && (rowData["given_name"] === "" || !rowData["given_name"])) {
                error = error + " <strong>" + (row ) + ". satırdaki 'Adı_(Tckn_için_zorunlu)' alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if ((rowData["vkn_tckn"].toString().length === 11 || rowData["is_foreign_customer"].toUpperCase() === "EVET") && (rowData["family_name"] === "" || !rowData["family_name"])) {
                error = error + " <strong>" + (row ) + ". satırdaki 'Soyadı_(Tckn_için_zorunlu)' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["customer_type"] === "" || !rowData["customer_type"]) {
                error = error + " <strong>" + (row ) + ". satırdaki 'Müşteri_Tipi_(Zorunlu)' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["address_name"] === "" || !rowData["address_name"]) {
                error = error + " <strong>" + (row ) + ". satırdaki 'Adres_Adı_(Zorunlu)' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["country_name"] === "" || !rowData["country_name"]) {
                error = error + " <strong>" + (row ) + ". satırdaki 'Ülke_(Zorunlu)' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["city_name"] === "" || !rowData["city_name"]) {
                error = error + " <strong>" + (row ) + ". satırdaki 'Şehir_(Zorunlu)' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["city_subdivision_name"] === "" || !rowData["city_subdivision_name"]) {
                error = error + " <strong>" + (row ) + ". satırdaki 'İlçe_(Zorunlu)' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            }
            else if (!(rowData["telephone"] === "")) {
                let regex = new RegExp(/^\+(90\d{10})$/g);
                let regexForeign = new RegExp(/^\+(\d{11,15})$/g);

                if (/^90\d{10}$/.test(rowData["telephone"])) {
                    rowData["telephone"] = "+" + rowData["telephone"];
                }

                if (!regex.test(rowData["telephone"].toString())) {
                    rowData["telephone"] = "+90" + rowData["telephone"];
                }

                if (!(regexForeign.test(rowData["telephone"].toString())) && (rowData["is_foreign_customer"].toUpperCase() === "EVET")) {
                    error = error + " <strong>" + (row) + ". satırdaki 'Telefon' alanı yanlış doldurulmuştur </strong><br/>";
                    controlObject = 0;
                }

                if (!/^\+90\d{10}$/.test(rowData["telephone"])) {
                    error = error + " <strong>" + (row) + ". satırdaki 'Telefon' alanı eksik veya fazla doldurulmuştur </strong><br/>";
                    controlObject = 0;
                }

                if (/^\+900\d+$/.test(rowData["telephone"])) {
                    error = error + " <strong>" + (row) + ". satırdaki 'Telefon' alanı yanlış doldurulmuştur </strong><br/>";
                    controlObject = 0;
                }
            }
        }
        return {error, controlObject};
    }

    static sVoucherValidation(rowData, row, controlObject) {
        let error = "";
        let list = ["000", "021", "022", "023",0o21, 0o22, 0o23];
        let list0 = [21, 22, 23, "21", "22", "23"];

        if (rowData["vknTckn"] !== null && row !== 0) {
            if(isNaN(rowData["vknTckn"]) || (rowData["vknTckn"].toString().length !== 11 && rowData["vknTckn"].toString().length !== 10) || rowData["vknTckn"] < 0 || rowData["vknTckn"].toString().includes("+") ){
                error = error + " <strong>" + (row + 1) + ". satırdaki TCKN_VKN satırı 10 veya 11 haneli pozitif bir sayı olmalıdır, harf içeremez. </strong><br/>";
                controlObject = 0;
            }else {
                if (rowData["vknTckn"].toString().length === 10 && (rowData["formattedName"] === "" || !rowData["formattedName"])) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki verilerinizin unvan alanı boş olamaz </strong><br/>";
                    controlObject = 0;
                } else if (rowData["vknTckn"].toString().length === 11 && row !== 0 && ((rowData["givenName"] === "" || !rowData["givenName"]) || (rowData["familyName"] === "" || !rowData["familyName"]))) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki verilerinizin müşteri ad veya soyad alanları boş olamaz </strong><br/>";
                    controlObject = 0;
                }
            }
        } else if (row !== 0) {
            error = error + " <strong>" + (row + 1) + ". satırdaki VKN/TCKN alanı boş olamaz </strong><br/>";
            controlObject = 0;
        }
        if (row !== 0) {
            if(list0.includes(rowData["gvStoppageCode"])){
                rowData["gvStoppageCode"] = "0" + rowData["gvStoppageCode"];
            }
            if (rowData["cityName"] === "" || !rowData["cityName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'il'alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if (rowData["citySubdivisionName"] === "" || !rowData["citySubdivisionName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ILCE' alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if (rowData["issueDate"] === "" || !rowData["issueDate"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TARIH' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["documentNo"] === "" || !rowData["documentNo"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'MAKBUZ NO' alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["issueDate"],"DD-MM-YYYY HH:mm:ss").isValid("DD-MM-YYYY HH:mm:ss"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TARIH'formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            } else if (rowData["itemName"] === "" || !rowData["itemName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'URUN' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["tevkifatAmount"] >= 0) || rowData["tevkifatAmount"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV_TEVKIFATI' alanı boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["gercekAmount"] >= 0) || rowData["gercekAmount"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV_GERCEK' alanı boş olamaz veya harf barındıramaz</strong><br/>";
                controlObject = 0;
            } else if (!(rowData["lineExtensionAmount"] >= 0) || rowData["lineExtensionAmount"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'BRUT_UCRET' alanı boş olamaz veya harf barındıramaz</strong><br/>";
                controlObject = 0;
            } else if (!(rowData["gvStoppageCode"] >= 0) || rowData["gvStoppageCode"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'GV_STOPAJI_KODU' alanı boş olamaz veya harf barındıramaz</strong><br/>";
                controlObject = 0;
            } else if (!(list.includes(rowData["gvStoppageCode"]))){
                error = error + " <strong>" + (row + 1) + ". satıdaki 'GV_STOPAJI_KODU' alanına uygun kodlar harici kod girilemez</strong><br/>";
                controlObject = 0;
            }
        }
        return {error, controlObject};
    }

    static voucherValidation(rowData, row, controlObject) {
        let error = "";
        let list = ['000', '091', '092', '093', '094','095','096'];
        let list0 = [91, 92, 93, 94, 95, 96, '91', '92', '93', '94', '95', '96'];

        if (rowData["vknTckn"] !== null && row !== 0) {
            if(isNaN(rowData["vknTckn"]) || (rowData["vknTckn"].toString().length !== 11 && rowData["vknTckn"].toString().length !== 10) || rowData["vknTckn"] < 0 || rowData["vknTckn"].toString().includes("+")){
                error = error + " <strong>" + (row + 1) + ". satırdaki TCKN_VKN satırı 10 veya 11 haneli pozitif bir sayı olmalıdır, harf içeremez. </strong><br/>";
                controlObject = 0;
            }else {
                if (rowData["vknTckn"].toString().length === 11 && row !== 0 && ((rowData["fullName"] === "" || !rowData["fullName"]))) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki verilerinizin müşteri ad veya soyad alanları boş olamaz </strong><br/>";
                    controlObject = 0;
                }
            }
        } else if (row !== 0 || rowData["vknTckn"] === "" || !rowData["vknTckn"]) {
            error = error + " <strong>" + (row + 1) + ". satırdaki VKN/TCKN alanı boş olamaz </strong><br/>";
            controlObject = 0;
        }
        if (row !== 0) {
            if(list0.includes(rowData["gvStoppageCode"])){
                rowData["gvStoppageCode"] = "0" + rowData["gvStoppageCode"];
            }
            if (rowData["issueDate"] === "" || !rowData["issueDate"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TARIH' alanı  boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["issueDate"],"DD-MM-YYYY HH:mm:ss").isValid("DD-MM-YYYY HH:mm:ss"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TARIH'formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            } else if (rowData["documentNo"] === "" || !rowData["documentNo"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'MAKBUZ NO' alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if (rowData["fullAddress"] === "" || !rowData["fullAddress"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ADRES(EK BİLGİ /İLÇE / İL)' alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if (rowData["itemName"] === "" || !rowData["itemName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ÜRÜN' alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["quantity"] >= 0) || rowData["quantity"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'MİKTAR' alanı  boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["unitPrice"] >= 0) || rowData["unitPrice"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'B.FİYAT' alanı  boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["unitPrice"] >= 0) || rowData["unitPrice"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'GV_STOPAJI' alanı  boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["lineExtensionAmount"] >= 0) || rowData["lineExtensionAmount"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TUTAR' alanı  boş olamaz  veya harf barındıramaz</strong><br/>";
                controlObject = 0;
            } else if (rowData["unit"] === "" || !rowData["unit"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'BIRIM' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["gvStoppageCode"] >= 0) || rowData["gvStoppageCode"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'GV_STOPAJI_KODU' alanı boş olamaz veya harf barındıramaz</strong><br/>";
                controlObject = 0;
            } else if (!(list.includes(rowData["gvStoppageCode"]))){
                error = error + " <strong>" + (row + 1) + ". satıdaki 'GV_STOPAJI_KODU' alanına uygun kodlar harici kod girilemez</strong><br/>";
                controlObject = 0;
            }
        }
        return {error, controlObject};
    }


    static requestBankValidation(rowData, row, controlObject){
        let error = "";
        if (row !== 0) {
            // if (rowData["urun_hizmet"] === "" || !rowData["urun_hizmet"]) {
            //     error = error + " <strong>" + (row) + ". satırdaki 'urun_hizmet'alanını kontrol ediniz  </strong><br/>";
            //     controlObject = 0;
            // }else if (rowData["urun_id"] === "" || !rowData["urun_id"]) {
            //     error = error + " <strong>" + (row) + ". satırdaki 'urun_id' alanını kontrol ediniz </strong><br/>";
            //     controlObject = 0;
            // } else
                if (rowData["olay_numarasi"] === "" || !rowData["olay_numarasi"]) {
                error = error + " <strong>" + (row) + ". satırdaki 'olay_numarasi' alanını kontrol ediniz  </strong><br/>";
                controlObject = 0;
            }
        }
        return {error, controlObject};
    }

    static invoiceValidation(rowData, row, controlObject, type,exemptions,withholdingCodes) {
        let error = "";
        let paymentMethods = ["KREDIKARTI/BANKAKARTI","EFT/HAVALE","KAPIDAODEME","ODEMEARACISI","DIGER"]
        if (rowData["vknTckn"] !== null && row !== 0) {
            if(isNaN(rowData["vknTckn"]) || (rowData["vknTckn"].toString().length !== 11 && rowData["vknTckn"].toString().length !== 10) || rowData["vknTckn"] < 0 || rowData["vknTckn"].toString().includes("+")){
                error = error + " <strong>" + (row + 1) + ". satırdaki TCKN_VKN satırı 10 veya 11 haneli pozitif bir sayı olmalıdır, harf içeremez. </strong><br/>";
                controlObject = 0;
            }else {
                if (rowData["vknTckn"].toString().length === 10 && (rowData["formattedName"] === "" || !rowData["formattedName"])) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki verilerinizin unvan alanı boş olamaz </strong><br/>";
                    controlObject = 0;
                } else if (rowData["vknTckn"].toString().length === 11 && row !== 0 && ((rowData["givenName"] === "" || !rowData["givenName"]) || (rowData["familyName"] === "" || !rowData["familyName"]))) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki verilerinizin müşteri ad veya soyad alanları boş olamaz </strong><br/>";
                    controlObject = 0;
                }
            }
            if (!!rowData["givenName"] && rowData["givenName"].toString().length > 45) {
                error = error + " <strong>" + (row + 1) + ". satırdaki alıcı adı alanı maksimum 45 karakter olmalıdır </strong><br/>";
                controlObject = 0;
            }

            if (!!rowData["familyName"] && rowData["familyName"].toString().length > 45) {
                error = error + " <strong>" + (row + 1) + ". satırdaki alıcı soyadı alanı maksimum 45 karakter olmalıdır </strong><br/>";
                controlObject = 0;
            }

        } else if (row !== 0) {
            error = error + " <strong>" + (row + 1) + ". satırdaki VKN/TCKN alanı boş olamaz </strong><br/>";
            controlObject = 0;
        }
        if (row !== 0) {
            if (rowData["documentNo"] === "" || !rowData["documentNo"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'FATURA_NO'alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if (rowData["profileId"] === "" || !rowData["profileId"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'SENARYO_TURU' alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if (rowData["invoiceTypeCode"] === "" || !rowData["invoiceTypeCode"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'FATURA_TIPI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if ((rowData["destinationUrn"] === "" || !rowData["destinationUrn"]) && type !== "EARSIVFATURA") {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ALICI_POSTA_KUTUSU_ETIKETI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if ((rowData["sourceUrn"] === "" || !rowData["sourceUrn"]) && type !== "EARSIVFATURA") {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'GONDERICI_BIRIM_ETIKETI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if ((rowData["invoiceNumber"] === "" || !rowData["invoiceNumber"]) && rowData["invoiceTypeCode"] === "IADE") {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IADE_FATURA_NUMARASI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if ((rowData["iadeIssueDate"] === "" || !rowData["iadeIssueDate"]) && rowData["invoiceTypeCode"] === "IADE") {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IADE_FATURA_TARIHI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if ((rowData["iadeIssueTime"] === "" || !rowData["iadeIssueTime"]) && rowData["invoiceTypeCode"] === "IADE") {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IADE_FATURA_SAATI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["email"] === "" || !rowData["email"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ALICI_EPOSTA' alanını boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["documentCurrencyCode"] === "" || !rowData["documentCurrencyCode"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'PARA_BIRIMI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["citySubdivisionName"] === "" || !rowData["citySubdivisionName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ILCE' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["cityName"] === "" || !rowData["cityName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IL' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["countryName"] === "" || !rowData["countryName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ULKE' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["streetName"] === "" || !rowData["streetName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ADRES' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["itemName"] === "" || !rowData["itemName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'URUN_ADI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["quantity"] >= 0) || rowData["quantity"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'MIKTAR' alanı boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["unitPrice"] >= 0) || rowData["unitPrice"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'BIRIM_FIYAT' alanı boş olamaz veya harf barındıramaz</strong><br/>";
                controlObject = 0;
            } else if (rowData["unit"] === "" || !rowData["unit"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'BIRIM' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["iskontoPercentage"] >= 0) || rowData["iskontoPercentage"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ISKONTO(%)' alanı boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["kdvPercentage"] == null || typeof rowData["kdvPercentage"] !== 'number') {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV(%)' alanı boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["kdvPercentage"] != null || typeof rowData["kdvPercentage"] === 'number') {
                if ("zirve" !== VirtualHost.conf.resourcePrefix) {
                    let kdvpercantage = new Decimal(rowData["kdvPercentage"]);
                    if (!(kdvpercantage.eq(new Decimal(0)) ||
                        kdvpercantage.eq(new Decimal(1)) ||
                        kdvpercantage.eq(new Decimal(8)) ||
                        kdvpercantage.eq(new Decimal(10)) ||
                        kdvpercantage.eq(new Decimal(18)) ||
                        kdvpercantage.eq(new Decimal(20)))) {
                        error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV(%)' alanı 0,1,8,10,18,20 değerlerinden biri olmalıdır </strong><br/>";
                        controlObject = 0;
                    }
                }
            } else if (((rowData["invoiceTypeCode"] ==="TEVKIFAT" ) || (rowData["profileId"] ==="YOLCUBERABERFATURA")) && ( rowData["kdvPercentage"] === 0 && rowData["exemptionReasonCode"] !== null ) ){
                error = error + " <strong>" + (row + 1) + ". satırda belirtilen fatura tipi için 'İSTİSNA KODU' girilemez, 'KDV(%)' sıfır olamaz! </strong><br/>";
                controlObject = 0;
            } else if ((rowData["kdvPercentage"] === 0) && (rowData["exemptionReasonCode"] === null || rowData["exemptionReasonCode"] === "")) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV(%)' sıfır olduğundan KDV 'İSTİSNA KODU' girilmelidir! </strong><br/>";
                controlObject = 0;
            } else if ((rowData["exemptionReasonCode"] !== null && rowData["exemptionReasonCode"] !== "") && (rowData["kdvPercentage"] !== 0 && rowData["kdvPercentage"] !== null)) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'İSTİSNA KODU' dolu olduğundan 'KDV(%)' sıfır girilmelidir! </strong><br/>";
                controlObject = 0;
            } else if (rowData["gtip"] && (rowData["gtip"].toString().length !== 12 || isNaN(rowData["gtip"]) || rowData["gtip"] < 0 || rowData["gtip"].toString().includes("+"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'Gtip Numarası' harf içeremez, negatif olamaz ve 12 basamaktan oluşmalıdır. </strong><br/>";
                controlObject = 0;
            } else if (rowData["profileId"] === "IHRACAT" && !rowData["gtip"]){
                error = error + " <strong>" + (row + 1) + ". satırdaki 'GTİP NUMARSI' İhracat Fatura için zorunludur. </strong><br/>";
                controlObject = 0;
            } else if (rowData["issueDate"] === "" || !rowData["issueDate"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TARIH' alanı  boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["issueDate"],"DD-MM-YYYY").isValid("DD-MM-YYYY"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TARIH' formatını doğru yazdığınızdan emin olun. </strong><br/>";
                controlObject = 0;
            } else if (rowData["issueTime"] === "" || !rowData["issueTime"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TARIH' alanı  boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["issueTime"],"HH:mm:ss").isValid("HH:mm:ss"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'FATURA_SAATI' formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            } else if (((rowData["exemptionReasonCode"] !== null && rowData["exemptionReasonCode"] !== "") && (rowData["kdvPercentage"] === 0 || rowData["kdvPercentage"] === null))) {
                if(getExemptions(exemptions,"KDV" ,rowData["invoiceTypeCode"]).filter(item=>item.value === (rowData["exemptionReasonCode"])).length===0){
                    error = error + " <strong>" + (row + 1) + ". satırda girilen 'FATURA_TİPİ' için yanlış 'İSTİSNA KODU' seçilmiştir! </strong><br/>";
                    controlObject = 0;
                }
            } else if (rowData["email"] === "" || !rowData["email"] && type !== "EARSIVFATURA") {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ALICI_EPOSTA' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(validator.isEmail(rowData["email"])) && type !== "EARSIVFATURA") {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ALICI_EPOSTA'formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            } else if (rowData["invoiceTypeCode"] ==="TEVKIFAT" && (rowData["tevkifatAmount"] === null || rowData["tevkifatAmount"] === "" )) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV_TEVKIFATI' alanı fatura türü TEVKIFAT olduğunda boş olamaz. </strong><br/>";
                controlObject = 0;
            } else if (rowData["invoiceTypeCode"] !== "TEVKIFAT" && rowData["tevkifatAmount"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV_TEVKIFATI' sadece fatura türü 'TEVKIFAT' ise dolu olabilir. </strong><br/>";
                controlObject = 0;
            } else if (rowData["invoiceTypeCode"] === "TEVKIFAT" && rowData["tevkifatAmount"]) {
                if (withholdingCodes.filter(item => item.code === rowData["tevkifatAmount"].toString()).length === 0) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV_TEVKIFATI' sadece 'KDV TEVKIFATI KODLARI' sayfasından seçilebilir.</strong><br/>";
                    controlObject = 0;
                }
            } else if (rowData["referenceId"] && rowData["referenceId"] !== "") {
                if (rowData["referenceIssueDate"] === "" || !rowData["referenceIssueDate"]) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki 'İRSALİYE NO' alanı dolu olduğundan  'İRSALİYE TARIHİ' alanı  boş olamaz </strong><br/>";
                    controlObject = 0;
                }
                if (!(moment(rowData["referenceIssueDate"], "DD-MM-YYYY").isValid("DD-MM-YYYY")) && !(moment(rowData["referenceIssueDate"]).isValid("DD-MM-YYYY"))) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki 'İRSALİYE TARİHİ' formatını doğru yazdığınızdan emin olun </strong><br/>";
                    controlObject = 0;
                }
            } else if (!rowData["referenceId"] || rowData["referenceId"] === "") {
                if (rowData["referenceIssueDate"] && rowData["referenceIssueDate"] !== "" && rowData["referenceIssueDate"] !== "1900-01-0") {
                    error = error + " <strong>" + (row + 1) + ". satırdaki 'İRSALİYE NO' alanı boş olduğundan 'İRSALİYE TARİHİ' alanı  dolu olamaz </strong><br/>";
                    controlObject = 0;
                }
            } else if (rowData["internetSaleArea"]) {
                if (rowData["paymentDate"]) {
                    if (!(moment(rowData["paymentDate"], "DD-MM-YYYY").isValid("DD-MM-YYYY")) && !(moment(rowData["paymentDate"]).isValid("DD-MM-YYYY"))) {
                        error = error + " <strong>" + (row + 1) + ". satırdaki 'ODEME TARIHI' formatını doğru yazdığınızdan emin olun </strong><br/>";
                        controlObject = 0;
                    }
                }
                if (rowData["webSite"]) {
                    if (!(new RegExp(/^(http(s){0,1}:\/\/)?([a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+.*)$/g).test(rowData["webSite"]))) {
                        error = error + " <strong>" + (row + 1) + ". satırdaki 'Satış Web Sitesi' url formatı doğru değil. </strong><br/>";
                        controlObject = 0;
                    }
                }
                if (rowData["deliveryDate"]) {
                    if (!(moment(rowData["deliveryDate"], "DD-MM-YYYY").isValid("DD-MM-YYYY")) && !(moment(rowData["deliveryDate"]).isValid("DD-MM-YYYY"))) {
                        error = error + " <strong>" + (row + 1) + ". satırdaki 'GONDERIM TARIHI' formatını doğru yazdığınızdan emin olun </strong><br/>";
                        controlObject = 0;
                    }
                }
                if (rowData["carrierVknTckn"]) {
                    if ((rowData["carrierVknTckn"].toString().length !== 11 && rowData["carrierVknTckn"].toString().length !== 10) || rowData["carrierVknTckn"] < 0 || rowData["carrierVknTckn"].toString().includes("+")) {
                        error = error + " <strong>" + (row + 1) + ". satırdaki TASIYICI TCKN_VKN satırı 10 veya 11 haneli pozitif bir sayı olmalıdır, harf içeremez. </strong><br/>";
                        controlObject = 0;
                    }
                }
                if (rowData["paymentMethod"]) {
                    if (paymentMethods.filter(item => item === rowData["paymentMethod"]).length === 0) {
                        error = error + " <strong>" + (row + 1) + ". satırdaki 'ODEME_SEKLI' sadece 'ODEME_SEKLI_TIPLERI' sekmesinden seçilebilir.</strong><br/>";
                        controlObject = 0;
                    }
                    else{
                        if((rowData["paymentDate"]==="null" || rowData["paymentDate"]==="" || !rowData["paymentDate"])){
                            error = error + " <strong>" + (row + 1) + ". satırdaki 'ODEME TARIHI' alanını doldurunuz.</strong><br/>";
                            controlObject = 0;
                        }
                        if((rowData["carrierTitle"]==="null" || rowData["carrierTitle"]==="" || !rowData["carrierTitle"])){
                            error = error + " <strong>" + (row + 1) + ". satırdaki 'TASIYICI_UNVAN' alanını doldurunuz.</strong><br/>";
                            controlObject = 0;
                        }
                        if((rowData["carrierVknTckn"]==="null" || rowData["carrierVknTckn"]==="" || !rowData["carrierVknTckn"])){
                            error = error + " <strong>" + (row + 1) + ". satırdaki 'TASIYICI TCKN_VKN' alanını doldurunuz.</strong><br/>";
                            controlObject = 0;
                        }
                        if((rowData["deliveryDate"]==="null" || rowData["deliveryDate"]==="" || !rowData["deliveryDate"])){
                            error = error + " <strong>" + (row + 1) + ". satırdaki 'GONDERIM TARIHI' alanını doldurunuz.</strong><br/>";
                            controlObject = 0;
                        }
                    }
                    if(rowData["paymentMethod"]==="DIGER" && (rowData["paymentDetails"]==="null" || rowData["paymentDetails"]==="" || !rowData["paymentDetails"])) {
                        error = error + " <strong>" + (row + 1) + ". satırdaki 'ODEME_SEKLI' 'DIGER' seçildiğinden 'ODEME_DETAYI' satırına açıklama girmelisiniz.</strong><br/>";
                        controlObject = 0;
                    }
                }
            }
        }
        return {error, controlObject};
    }

    static belgeValidation(rowData, row, controlObject, type,exemptions,withholdingCodes) {
        let error = "";
        if (rowData["vknTckn"] !== null && row !== 0) {
            if(isNaN(rowData["vknTckn"]) || (rowData["vknTckn"].toString().length !== 11 && rowData["vknTckn"].toString().length !== 10) || rowData["vknTckn"] < 0 || rowData["vknTckn"].toString().includes("+")){
                error = error + " <strong>" + (row + 1) + ". satırdaki TCKN_VKN satırı 10 veya 11 haneli pozitif bir sayı olmalıdır, harf içeremez. </strong><br/>";
                controlObject = 0;
            }else {
                if (rowData["vknTckn"].toString().length === 10 && (rowData["formattedName"] === "" || !rowData["formattedName"])) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki verilerinizin unvan alanı boş olamaz </strong><br/>";
                    controlObject = 0;
                } else if (rowData["vknTckn"].toString().length === 11 && row !== 0 && ((rowData["givenName"] === "" || !rowData["givenName"]) || (rowData["familyName"] === "" || !rowData["familyName"]))) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki verilerinizin müşteri ad veya soyad alanları boş olamaz </strong><br/>";
                    controlObject = 0;
                }
            }
        } else if (row !== 0) {
            error = error + " <strong>" + (row + 1) + ". satırdaki VKN/TCKN alanı boş olamaz </strong><br/>";
            controlObject = 0;
        }
        if (row !== 0) {
            if (rowData["documentNo"] === "" || !rowData["documentNo"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'FATURA_NO'alanı  boş olamaz  </strong><br/>";
                controlObject = 0;
            } else if (rowData["documentTypeCode"] === "" || !rowData["documentTypeCode"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'FATURA_TIPI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            }  else if (rowData["email"] === "" || !rowData["email"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ALICI_EPOSTA' alanını boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["documentCurrencyCode"] === "" || !rowData["documentCurrencyCode"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'PARA_BIRIMI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["citySubdivisionName"] === "" || !rowData["citySubdivisionName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ILCE' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["cityName"] === "" || !rowData["cityName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'IL' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["countryName"] === "" || !rowData["countryName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ULKE' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["streetName"] === "" || !rowData["streetName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ADRES' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["itemName"] === "" || !rowData["itemName"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'URUN_ADI' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["quantity"] >= 0) || rowData["quantity"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'MIKTAR' alanı boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["unitPrice"] >= 0) || rowData["unitPrice"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'BIRIM_FIYAT' alanı boş olamaz veya harf barındıramaz</strong><br/>";
                controlObject = 0;
            } else if (rowData["unit"] === "" || !rowData["unit"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'BIRIM' alanı boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(rowData["iskontoPercentage"] >= 0) || rowData["iskontoPercentage"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'ISKONTO(%)' alanı boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            } else if (rowData["kdvPercentage"] == null) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV(%)' alanı boş olamaz veya harf barındıramaz </strong><br/>";
                controlObject = 0;
            } else if (((rowData["documentTypeCode"] ==="TEVKIFAT" ) || (rowData["profileId"] ==="YOLCUBERABERFATURA")) && ( rowData["kdvPercentage"] === 0 && rowData["exemptionReasonCode"] !== null ) ){
                error = error + " <strong>" + (row + 1) + ". satırda belirtilen fatura tipi için 'İSTİSNA KODU' girilemez, 'KDV(%)' sıfır olamaz! </strong><br/>";
                controlObject = 0;
            } else if ((rowData["kdvPercentage"] === 0) && (rowData["exemptionReasonCode"] === null || rowData["exemptionReasonCode"] === "")) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV(%)' sıfır olduğundan KDV 'İSTİSNA KODU' girilmelidir! </strong><br/>";
                controlObject = 0;
            } else if ((rowData["exemptionReasonCode"] !== null && rowData["exemptionReasonCode"] !== "") && (rowData["kdvPercentage"] !== 0 && rowData["kdvPercentage"] !== null)) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'İSTİSNA KODU' dolu olduğundan 'KDV(%)' sıfır girilmelidir! </strong><br/>";
                controlObject = 0;
            } else if (rowData["gtip"] && (rowData["gtip"].toString().length !== 12 || isNaN(rowData["gtip"]) || rowData["gtip"] < 0 || rowData["gtip"].toString().includes("+"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'Gtip Numarası' harf içeremez, negatif olamaz ve 12 basamaktan oluşmalıdır. </strong><br/>";
                controlObject = 0;
            }  else if (rowData["issueDate"] === "" || !rowData["issueDate"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TARIH' alanı  boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["issueDate"],"DD-MM-YYYY").isValid("DD-MM-YYYY"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TARIH' formatını doğru yazdığınızdan emin olun. </strong><br/>";
                controlObject = 0;
            } else if (rowData["issueTime"] === "" || !rowData["issueTime"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'TARIH' alanı  boş olamaz </strong><br/>";
                controlObject = 0;
            } else if (!(moment(rowData["issueTime"],"HH:mm:ss").isValid("HH:mm:ss"))) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'FATURA_SAATI' formatını doğru yazdığınızdan emin olun </strong><br/>";
                controlObject = 0;
            } else if (((rowData["exemptionReasonCode"] !== null && rowData["exemptionReasonCode"] !== "") && (rowData["kdvPercentage"] === 0 || rowData["kdvPercentage"] === null))) {
                if(getExemptions(exemptions,"KDV" ,rowData["documentTypeCode"]).filter(item=>item.value === (rowData["exemptionReasonCode"])).length===0){
                    error = error + " <strong>" + (row + 1) + ". satırda girilen 'FATURA_TİPİ' için yanlış 'İSTİSNA KODU' seçilmiştir! </strong><br/>";
                    controlObject = 0;
                }
            }  else if (rowData["documentTypeCode"] ==="TEVKIFAT" && (rowData["tevkifatAmount"] === null || rowData["tevkifatAmount"] === "" )) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV_TEVKIFATI' alanı fatura türü TEVKIFAT olduğunda boş olamaz. </strong><br/>";
                controlObject = 0;
            } else if (rowData["documentTypeCode"] !=="TEVKIFAT" && rowData["tevkifatAmount"]) {
                error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV_TEVKIFATI' sadece fatura türü 'TEVKIFAT' ise dolu olabilir. </strong><br/>";
                controlObject = 0;
            } else if (rowData["documentTypeCode"] ==="TEVKIFAT" && rowData["tevkifatAmount"]) {
                if(withholdingCodes.filter(item=>item.code===rowData["tevkifatAmount"].toString()).length === 0){
                    error = error + " <strong>" + (row + 1) + ". satırdaki 'KDV_TEVKIFATI' sadece 'KDV TEVKIFATI KODLARI' sayfasından seçilebilir.</strong><br/>";
                    controlObject = 0;
                }
            } else if (rowData["referenceId"] && rowData["referenceId"] !== "") {
                if (rowData["referenceIssueDate"] === "" || !rowData["referenceIssueDate"]) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki 'İRSALİYE NO' alanı dolu olduğundan  'İRSALİYE TARIHİ' alanı  boş olamaz </strong><br/>";
                    controlObject = 0;
                }
                if (!(moment(rowData["referenceIssueDate"],"DD-MM-YYYY").isValid("DD-MM-YYYY")) && !(moment(rowData["referenceIssueDate"]).isValid("DD-MM-YYYY"))) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki 'İRSALİYE TARİHİ' formatını doğru yazdığınızdan emin olun </strong><br/>";
                    controlObject = 0;
                }
            } else if (!rowData["referenceId"] || rowData["referenceId"] === "") {
                if (rowData["referenceIssueDate"] && rowData["referenceIssueDate"] !== "" && rowData["referenceIssueDate"] !== "1900-01-0" ) {
                    error = error + " <strong>" + (row + 1) + ". satırdaki 'İRSALİYE NO' alanı boş olduğundan 'İRSALİYE TARİHİ' alanı  dolu olamaz </strong><br/>";
                    controlObject = 0;
                }
            }
        }
        return {error, controlObject};
    }

    static setNameRequestBank(rowData, controlObject, row) {
        if (controlObject) {
            if (row !== 0) {
                // if (rowData["urun_hizmet"] == null) {
                //     rowData["urun_hizmet"] = null;
                // } else
                    if (rowData["olay_numarasi"] == null) {
                    rowData["olay_numarasi"] = null;
                }
                //     else if (rowData["urun_id"] == null) {
                //     rowData["urun_id"] = null;
                // }
            }
        }
        return rowData;
    }

    static setName(rowData, controlObject, row) {
        if (controlObject) {
            if (rowData["vknTckn"].toString().length === 10 && row !== 0 && rowData["formattedName"]) {
                if (rowData["givenName"] == null) {
                    rowData["givenName"] = null;
                }
                if (rowData["familyName"] == null) {
                    rowData["familyName"] = null;
                }
            } else if (rowData["vknTckn"].toString().length === 11 && row !== 0 && (rowData["givenName"] || rowData["familyName"])) {
                if (rowData["formattedName"] == null) {
                    rowData["formattedName"] = null;
                }
            }
        }
        return rowData;
    }

    static getHeaderVoucherValidation(voucherEnum) {
        let flag = 0;
        for (let i = 0; i < 15; i++) {
            for (let k = 0; k < voucherEnum.length; k++) {
                if (VoucherEnum[i] === voucherEnum[k][k]) {
                    flag = flag + 1;
                }
            }
        }
        return flag === 15 || flag === 14;
    }

    static getHeaderInvoiceValidation(invoiceEnum) {
        let flag = 0;
        for (let i = 0; i < 30; i++) {
            for (let k = 0; k < invoiceEnum.length; k++) {
                if (InvoiceEnum[i] === invoiceEnum[k][k]) {
                    flag = flag + 1;
                }
            }
        }
        return flag === 30;
    }

    static getHeaderRequestBankValidation(requestEnum) {
        let flag = 0;
        for (let i = 0; i < 1; i++) {
            for (let k = 0; k < requestEnum.length; k++) {
                if (requestEnum[i][i] === requestEnum[k][k]) {
                    flag = flag + 1;
                }
            }
        }
        return flag === 1;
    }

    static getHeaderBelgeValidation(belgeEnum) {
        let flag = 0;
        for (let i = 0; i < 27; i++) {
            for (let k = 0; k < belgeEnum.length; k++) {
                if (BelgeEnum[i] === belgeEnum[k][k]) {
                    flag = flag + 1;
                }
            }
        }
        return flag === 27;
    }

    static getHeaderSVoucherValidation(serbestVoucherEnum) {
        let flag = 0;
        for (let i = 0; i < 15; i++) {
            for (let k = 0; k < serbestVoucherEnum.length; k++) {
                if (SerbestVoucherEnum[i] === serbestVoucherEnum[k][k]) {
                    flag = flag + 1;
                }
            }
        }
        return flag === 15;
    }

    static getHeaderDespatchValidation(despatchEnum) {
        let flag = 0;
        for (let i = 0; i < 28; i++) {
            for (let k = 0; k < despatchEnum.length; k++) {
                if (DespatchEnum[i] === despatchEnum[k][k]) {
                    flag = flag + 1;
                }
            }
        }
        return flag === 28;
    }

    static getHeaderStockValidation(stockEnum) {
        let flag = 0;
        for (let i = 0; i < 12; i++) {
            for (let k = 0; k < stockEnum.length; k++) {
                if (StockEnum[i] === stockEnum[k][k]) {
                    flag = flag + 1;
                }
            }
        }
        return flag === 12;
    }

    static getHeaderSigortaValidation(sigortaEnum) {
        let flag = 0;
        for (let i = 0; i < 21; i++) {
            for (let k = 0; k < sigortaEnum.length; k++) {
                if (SigortaEnum[i] === sigortaEnum[k][k]) {
                    flag = flag + 1;
                }
            }
        }
        return flag === 21;
    }

    static getHeaderExternalCustomerValidation(externalCustomerEnum) {
        let flag = 0;
        for (let i = 0; i < 30; i++) {
            for (let k = 0; k < externalCustomerEnum.length; k++) {
                if (ExternalCustomerEnum[i] === externalCustomerEnum[k][k]) {
                    flag = flag + 1;
                }
            }
        }
        return flag === 30;
    }
}
export default GetEnumDataAndValidation;
